/**
 * Created by wangshhj on 2018/1/11.
 */
import React, { Component } from 'react';
import SearchComponent from './searchComponent';
// import shareTableMeta from './shareTableMeta';

import {
    isEmpty,
    ViewModel,
    setGlobalStorage,
    getGlobalStorage,
} from '@platform/api';

const defaultPlanKey = '00000000000000000000';

/*
 *   @ 查询区交互说明：
 *   1、如果查询区需要查询方案，并且不是只显示高级按钮时，则先请求查询方案 ；如果查询方案中有默认查询方案，则页面永远展示默认查询方案中的查询条件；否则，展示查询模板中的visible:true的查询条件；
 *   2、当用户修改了默认查询方案 ，需要实时更新同步查询区展示
 *   3、当用户点击查询方案去查询时（无论是外面的查询方案还是高级面板中的查询方案），外面查询区需要展示该方案中的未填写项（该未填写项只按照保存方案时标记，修改了查询方案中的查询条件但是未保存的不算）
 *   4、高级面板中，普通查询区不能拖拽多个相同的查询条件；
 *   5、高级面板中，高级区域可以拖拽多个相同的查询条件，但是，默认展示的查询条件不能移除，也不能拖到默认展示的查询条件之上形成一组新的查询条件。非默认显示的查询条件可以和拖拽项组成新的、带逻辑运算的查询条件
 *   6、默认查询方案只能修改不能删除
 *   7、clickSearchBtn方法，在点击查询方案触发查询时，只返回方案中的公共查询条件，不包含自定义查询条件；如果有自定义查询条件，需要业务组在clickPlanEve方法中接收查询方案信息，并保存到业务组的state中，然后在 clickSearchBtn方法中自行合并公共条件和自定义条件，再去请求查询。
 *   8、需要查询方案功能时，必须传参数oid（查询模板中的oid），可以通过createUIDom(data, callback)  回调拿到模板信息；
 *   9、当只显示高级按钮时，不加载简单查询区的查询条件和查询按钮，点方案进行查询也不加载方案中的未填写项。
 *
 * */
/**
 * 创建查询区
 * @memberof Search
 * @param {ModuleId} moduleId 查询区区域编码
 * @param {Config} config 查询区配置项
 * @returns {SearchComponent}
 */
export default function NCCreateSearch(
    moduleId,
    {
        //展示形态类的配置
        isWidgetMode = false,
        onlyShowAdvArea = false, //在查询区只显示 高级查询部分,
        onlyShowModal = false, //在查询区只显示 模态框,
        showAdvBtn = true, // 是否显示高级查询按钮和查询方案按钮 ,默认显示
        onlyShowSuperBtn = false, // 只显示高级按钮
        onlyShowPlan = false, // 只显示方案列表和高级按钮，应该废弃了，不知道有人用没，看样子是查询区收起时候的样子
        runMode = '',
        underlineBorder,
        dragForbidden = false, //禁用拖拽 包括高级查询的作树和右树

        //显示隐藏配置
        showSearchBtn = true, // 是否显示查询按钮 ,默认显示
        showClearBtn = true, // 是否显示清空按钮
        showClearCurrentBtn = false, // 是否显示清空按钮
        hideMoreBtn = false,
        showAdvSearchPlanBtn = true, // 高级面板中是否显示保存另存方案按钮
        hideBtnArea = false, // 隐藏查询按钮区域，默认false
        hideSearchCondition = false, // 隐藏候选条件
        hideSearchPlan = false, // 隐藏高级弹窗的查询方案
        showAddSearchPlan = true, //是否显示另存新方案按钮（只在普通查询中生效，不控制高级弹窗的另存新方案按钮）
        showFoldBtn = true, //是否显示展开收起图标
        isShowDefalutPage = true, //在高级查询中，业务自定义页签时，是否显示默认的查询条件页签
        hideSearchType = false, //隐藏高级和普通的radio
        onlyShowSuperCondition = false, //只显示高级查询，和hideSearchType配合使用
        showSearchLable = true, //是否显示条件名称，如果配置了不显示，则永远不显示
        showAdvSetDefault = true, //是否在高级弹窗中显示设置默认方案的功能
        showAddSearchResult = false,

        //通用配置
        context = '', //如果业务组传了上下文进来，就用业务组的数据，用于参照函数的翻译
        fieldid, //自动化测试标记
        useCache = true, //是否启用查询区缓存，默认启用
        syncAdvCondition = true, //在高级查询点击查询按钮后是否将查询条件同步到普通查询区
        isTemplateOrder = false, //默认不是模板顺序，如果是模板顺序，则取消必填项优先的逻辑
        currentSearch = true, //标识是否是当前正在操作的查询区，用于一个页面中有多个查询区的时候快捷键控制。
        searchKey = '',
        zIndex = 250,

        //应该配置在模板字段上的配置项
        hiddenFunList = {}, //日期组件用来隐藏一些日期函数，应该配置在模板字段上，目前模板没支持

        //文字替换配置
        searchBtnName = '', //替换查询按钮文字
        replaceSuperBtn = '', // 替换高级按钮文字
        searchModalTitle = '', // 高级查询 modal title
        searchConditionName = '', //高级查询 "查询条件" 名称自定义

        //回调事件配置
        onAfterEvent, // 编辑后事件
        onBeforeEvent,
        clickSearchBtn, // 查询按钮点击事件回调，只返回公共查询条件，不包含自定义查询条件；如果有自定义查询条件，需要业务组在clickPlanEve方法中接收查询方案信息，并保存到业务组的state中，然后在 clickSearchBtn方法中自行合并公共条件和自定义条件。
        saveSearchPlan, // 保存查询方案确定按钮事件 ，用于业务组返回自定义的查询条件
        clickPlanEve, // 点击高级面板中的查询方案事件 ,用于业务组为自定义查询区赋值
        clickAdvBtnEve, //单击高级之后的回调方法
        advSearchClearEve, // 高级查询面板中的清空按钮 点击事件回调，用于业务组清除自定义查询条件值
        advSearchClearCurrentEve,
        onOperateTypeChange, // 操作符改变时的回调
        renderCompleteEvent, //查询区渲染完成之后的回调事件
        statusChangeEvent, //切换查询区状态时的回调
        setInitValueEvent, //初始化四状态默认值的时候的回调函数
        onlyShowModalCancelCallback, // 只渲染modal时 关闭modal 触发的回调
        opneBtnClick, //展开收起按钮的单击事件，触发是在面板展开或关闭之后进行的
        removeQuerConditionEve, //移除查询条件的触发条件，返回ture 则 不能移除
        onDropConditionEve,
        modalCloseEve, //高级查询弹框点击取消和关闭的回调
        clickShowLableEve, //点击显示名称触发的回调

        //自定义渲染类配置
        replaceAdvBtnEve, // 业务组替换整个高级面板 (fun)
        replaceAdvBody, // 业务组替换高级面板中的body (fun)
        replaceRightBody, // 添加高级查询区右侧区域自定义查询条件Dom (fun)
        addAdvTabs, // 添加高级查询区自定义页签 (fun)
        addAdvBody, // 添加高级查询区自定义查询条件Dom (放在顶部)
        addAdvBodyBottom, //高级查询自定义区域（放在底部）
        customAppCode, //自定义应用编码
        customPageCode, //自定义页面编码
        hiddenShareBtn,
        customAdvBtns=[{key:'ok'},{key:'cancel'}], //高级查询自定义按钮
        //自定义类名
        shareModalClassName,
        maxColumn = 6, // 每行最多显示几列 默认 6
        advModalWidth, // 高级查询弹窗宽度
        advModalHeight, // 高级查询弹窗高度
        loadQuerySchemeWhenAdvSearch = false, //是否加载查询方案数据，默认加载
    } = {},
) {
    let _runContext = this.getQiankunContext();
    let meta = this.state.meta[moduleId];
    //模板没有值 就不渲染
    if (isEmpty(meta) || isEmpty(meta.items)) {
        return null;
    } else {
        function get_this(_this) {
            this.myState.search[`searchArea_${moduleId}`] = _this;
        }
        function getGloablThis() {
            return this;
        }
        function clear_this(){
            this.myState.search[`searchArea_${moduleId}`].props.currentSearch = false;
            // delete this.myState.search[`searchArea_${moduleId}`];
        }
        const templateAppCode = meta?.appcode;
        const templatePageCode = meta?.pagecode;
        //渲染监控=======
        // if (!this.hasOwnProperty('searchAreaRenderCount')) {
        //     this.searchAreaRenderCount = 1;
        // } else {
        //     this.searchAreaRenderCount++;
        // }
        // console.log('查询区组件渲染了' + this.searchAreaRenderCount + '次');

        //上下文信息:主要包含模板的context和businessInfo
        let contextMixin = {
            ...ViewModel.getContext(),
            ...(context || this.app_context),
        };

        // if(contextMixin && contextMixin.languageMetas){
        //     contextMixin.languageMetas.forEach((item,index) => {
        //         item.index = index + 1;
        //     })
        // }
        // console.log('contextMixin', contextMixin);
        //在创建查询区的时候给localstorage设置默认显示标识
        let isSynInitAdvSearch = false; //是否同步渲染高级查询
        let showLable = getGlobalStorage('localStorage', 'showLable');
        if (showLable === null) {
            setGlobalStorage('localStorage', 'showLable', false);
            showLable = false;
        } else {
            showLable = showLable === 'true';
        }
        if (runMode === 'preview') {
            showAdvSearchPlanBtn = false;
        }
        if(!meta.defaultDisPlay){
            meta.defaultDisPlay = defaultPlanKey;
        }
        // meta.defaultDisPlay = "";
        /**
         * 在2111版本之前，查询区没有设置默认方案的功能，模板中只有queryschemes，没有queryschemesdto（有用户设置默认的信息）。
         * 为了兼容之前业务的用法，需要将queryschemesdto转换为queryschemes添加到模板中
         */
        
        if (
            !Array.isArray(meta.queryschemes) &&
            Array.isArray(meta.queryschemesdto)
        ) {
            //先过滤多个查询区的情况后端返回的混乱数据
            let queryschemes = meta.queryschemesdto.filter(i => i.querySchemeVO?.areacode === moduleId);
            //找一下是否有用户设置过默认查询方案
            let defaultPlan = meta.queryschemesdto.find(i => i.querySchemeUserVO?.isdefaultdisplay) || {};
            //找快速查询
            let quickPlan = meta.queryschemesdto.find(i => i.querySchemeVO?.isquickqs) || {};
            //如果用户设置的默认方案则显示，如果没有设置默认有快速就显示快速方案，如果没有快速则显示 默认模板
            if(defaultPlan?.querySchemeVO?.pk_ncc_queryscheme){
                meta.defaultDisPlay = defaultPlan?.querySchemeVO?.pk_ncc_queryscheme
            }else if(quickPlan?.querySchemeVO?.pk_ncc_queryscheme &&  !meta.isclosequickquery){
                meta.defaultDisPlay = quickPlan?.querySchemeVO?.pk_ncc_queryscheme
            }else{
                meta.defaultDisPlay =  defaultPlanKey
            }
           
            //过滤掉默认模板
            queryschemes = queryschemes.filter(i => i.querySchemeVO?.pk_ncc_queryscheme !== defaultPlanKey).map(i => i.querySchemeVO);
            // meta.queryschemesdto.forEach(i => {
            //     let queryScheme = i.querySchemeVO;
            //     if(queryScheme.areacode === moduleId){
            //         if ( i.querySchemeUserVO?.isdefaultdisplay || (meta.defaultDisPlay === '00000000000000000000' && i.querySchemeVO?.isquickqs && )) {
            //             meta.defaultDisPlay = queryScheme.pk_ncc_queryscheme;
            //         }
            //         if (queryScheme.pk_ncc_queryscheme !== '00000000000000000000') {
            //             queryschemes.push(queryScheme);
            //         }

            //     }
                
            // });

            meta.queryschemes = queryschemes;
        }

        //在创建共享表格表格之前得先更新meta数据
        // meta['searchShareTable'] = shareTableMeta();

        // meta.searchShareTable.items.push({
        //     attrcode: 'opr',
        //     label: '操作',
        //     itemtype: 'customer',
        //     fixed: 'right',
        //     className: 'table-opr',
        //     visible: true,
        //     width: 250,
        //     render: (text, record, index) => {
        //         return <div>1111</div>;
        //     },
        // });

        return (
            <SearchComponent
                renderItem={
                    this.state.renderItem.search &&
                    this.state.renderItem.search.hasOwnProperty(moduleId)
                        ? this.state.renderItem.search[moduleId]
                        : {}
                } //全局参照列表
                context={contextMixin} //上下文数据 用于 函数翻译
                syncTree={this.syncTree} //树
                asyncTree={this.asyncTree} //同步树方法
                modal={this.modal}
                get_this={get_this.bind(this)}
                clear_this = {clear_this.bind(this)}
                search={this.search}
                getGloablThis={getGloablThis.bind(this)}
                moduleId={moduleId}
                oid={meta.oid}
                meta={meta}
                clickSearchBtn={clickSearchBtn}
                searchBtnName={searchBtnName}
                onAfterEvent={onAfterEvent}
                onBeforeEvent={onBeforeEvent}
                showSearchBtn={showSearchBtn}
                showAdvBtn={showAdvBtn}
                hideMoreBtn={hideMoreBtn}
                showClearBtn={showClearBtn}
                showClearCurrentBtn={showClearCurrentBtn}
                showAdvSearchPlanBtn={showAdvSearchPlanBtn}
                showAddSearchPlan={showAddSearchPlan}
                replaceAdvBtnEve={replaceAdvBtnEve}
                replaceAdvBody={replaceAdvBody}
                addAdvTabs={addAdvTabs}
                addAdvBody={addAdvBody}
                addAdvBodyBottom={addAdvBodyBottom}
                replaceRightBody={replaceRightBody}
                showLable={showLable}
                hideSearchCondition={hideSearchCondition}
                hideSearchPlan={hideSearchPlan}
                saveSearchPlan={saveSearchPlan}
                clickPlanEve={clickPlanEve}
                clickAdvBtnEve={clickAdvBtnEve}
                hideBtnArea={hideBtnArea}
                advSearchClearEve={advSearchClearEve}
                advSearchClearCurrentEve={advSearchClearCurrentEve}
                onlyShowSuperBtn={onlyShowSuperBtn}
                replaceSuperBtn={replaceSuperBtn}
                onOperateTypeChange={onOperateTypeChange}
                onlyShowAdvArea={onlyShowAdvArea}
                onlyShowModal={onlyShowModal}
                renderCompleteEvent={renderCompleteEvent}
                statusChangeEvent={statusChangeEvent}
                setInitValueEvent={setInitValueEvent}
                useCache={useCache}
                isSynInitAdvSearch={isSynInitAdvSearch}
                onlyShowModalCancelCallback={onlyShowModalCancelCallback}
                onlyShowPlan={onlyShowPlan}
                searchModalTitle={searchModalTitle}
                searchConditionName={searchConditionName}
                onlyShowSuperCondition={onlyShowSuperCondition}
                currentSearch={currentSearch}
                fieldid={fieldid}
                showFoldBtn={showFoldBtn}
                opneBtnClick={opneBtnClick}
                clickShowLableEve={clickShowLableEve}
                isTemplateOrder={isTemplateOrder}
                removeQuerConditionEve={removeQuerConditionEve}
                onDropConditionEve={onDropConditionEve}
                hideSearchType={hideSearchType}
                hiddenFunList={hiddenFunList}
                modalCloseEve={modalCloseEve}
                isShowDefalutPage={isShowDefalutPage}
                syncAdvCondition={syncAdvCondition}
                showSearchLable={showSearchLable}
                showAdvSetDefault={showAdvSetDefault}
                searchKey={searchKey}
                showAddSearchResult={showAddSearchResult}
                isWidgetMode={isWidgetMode}
                runMode={runMode}
                underlineBorder={underlineBorder}
                shareTableFunc={this.cardTable}
                metaFunc={this.meta}
                useFunc={this.use}
                customAppCode={customAppCode || templateAppCode}
                customPageCode={customPageCode || templatePageCode}
                hiddenShareBtn={hiddenShareBtn}
                _runContext={_runContext}
                shareModalClassName={shareModalClassName}
                dragForbidden={dragForbidden}
                zIndex={zIndex}
                maxColumn={maxColumn}
                customAdvBtns={customAdvBtns}
                advModalWidth={advModalWidth}
                advModalHeight={advModalHeight}
                loadQuerySchemeWhenAdvSearch={loadQuerySchemeWhenAdvSearch}
    
            />
        );
    }
}
